import { render, staticRenderFns } from "./RecImgTextList.vue?vue&type=template&id=e7c40a86&scoped=true&"
import script from "./RecImgTextList.vue?vue&type=script&lang=js&"
export * from "./RecImgTextList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c40a86",
  null
  
)

export default component.exports